import { Link, Navigate, useSearchParams } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/lib/auth-context'

export default function Login() {
  const { me } = useAuth()
  const [params] = useSearchParams()
  if (me) return <Navigate to="/app" replace />

  const error = params.get('error')

  return (
    <div className="flex h-full min-h-screen items-center justify-center px-6">
      <div className="w-full max-w-sm rounded-lg border bg-card p-7 shadow-sm">
        <Link to="/" className="mb-6 inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground">
          <div className="flex h-6 w-6 items-center justify-center rounded bg-primary text-primary-foreground">
            <svg viewBox="0 0 24 24" fill="currentColor" className="h-3 w-3"><path d="M22 5.8a8.5 8.5 0 0 1-2.4.7 4.2 4.2 0 0 0 1.8-2.3c-.8.5-1.7.8-2.7 1a4.2 4.2 0 0 0-7.1 3.8A11.9 11.9 0 0 1 3 4.9a4.2 4.2 0 0 0 1.3 5.6c-.7 0-1.3-.2-1.9-.5v.1a4.2 4.2 0 0 0 3.3 4.1 4.3 4.3 0 0 1-1.9.1A4.2 4.2 0 0 0 7.8 17 8.4 8.4 0 0 1 2 19a12 12 0 0 0 6.4 1.9c7.6 0 11.8-6.3 11.8-11.8v-.5A8.4 8.4 0 0 0 22 5.8"/></svg>
          </div>
          Bluebird
        </Link>

        <div className="space-y-5">
          <div>
            <h1 className="text-xl font-semibold">Sign in to Bluebird</h1>
            <p className="mt-1 text-sm text-muted-foreground">
              One click. We post and reply through your X account, so signing in with X is the whole account.
            </p>
          </div>

          {error && (
            <div className="rounded-md bg-destructive/10 px-3 py-2 text-xs text-destructive">
              {error === 'auth_failed' && 'X sign-in failed. Please try again.'}
              {error === 'invalid_state' && 'Session expired mid-login. Try again.'}
              {error === 'missing_params' && 'X redirected without the expected parameters.'}
              {!['auth_failed', 'invalid_state', 'missing_params'].includes(error) && error}
            </div>
          )}

          <Button asChild className="w-full" size="lg">
            <a href="/api/x/login">
              <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              Sign in with X
            </a>
          </Button>

          <p className="text-[11px] text-muted-foreground">
            We request read + write access so Bluebird can post on your approval. Your account isn't used for anything without a tap.
          </p>
        </div>
      </div>
    </div>
  )
}
